import { ModalBase } from './Modal';
import { ModalBody, ModalHead, ModalFooter } from './Modal.views';
ModalBase.displayName = "ModalBase";
ModalHead.displayName = "Modal.Head";
ModalBody.displayName = "Modal.Body";
ModalFooter.displayName = "Modal.Footer";
export { ModalBase as default, ModalBody as Body, ModalHead as Head, ModalFooter as Footer };
export { ModalOverlay as Overlay } from './ModalOverlay';